import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { isNil, isEmpty } from 'lodash';
import locale from 'antd/lib/date-picker/locale/el_GR';
import {
  Select,
  DatePicker,
  Row,
  Col,
  Table,
  Divider,
  Space,
  Tooltip,
  Spin,
  AutoComplete,
  Input,
  Modal,
  Button,
} from 'antd';
import { ReactComponent as SearchIcon } from '../../../../assets/icons/search_icon.gov.svg';
import { ReactComponent as ArrowIcon } from '../../../../assets/icons/dropdown-arrow.svg';
import { ReactComponent as CalendarIcon } from '../../../../assets/icons/calendar.gov.svg';
import {
  clearSayt,
  fetchProcessSAYT,
  getAllTaskNames,
  cancelProcessInstance,
  fetchProcInstancesDetailedPaginated,
  unassignProcessInstanceExtended
} from 'store/appTrack/actions';
import { ReactComponent as ActionsIcon } from '../../../../assets/icons/more_dots.svg';
import { ReactComponent as FilterIcon } from '../../../../assets/icons/filter_lines.svg';
import { ReactComponent as FilterIconBold } from '../../../../assets/icons/filter_lines_bold.svg';
import { ReactComponent as CancelWarningIcon } from '../../../../assets/icons/cancel_warning_icon.svg';
import Popover from '@mui/material/Popover';
import ActionList from './components/ActionList';
import TableCell from './components/TableCell';
import { StatusTag } from 'components';
import { isBeneficiary, isForeign } from 'utils';
import { getLocalString, localNames } from 'utils/localisation.service';
import { useNavigate } from 'react-router-dom';
import NoResults from './components/NoResults';
import {
  getSystemLocales,
  clearForm,
  kadBranchesService,
} from 'store/forms/actions';
import { setActiveFormId } from 'store/activeForm/actions';
import { checkUser, getUser, getTaxisData } from 'store/user/actions';

import { getFullDateTimeWithSeconds } from 'utils/helpers';
import { handleCheckUniqueness } from 'utils';
import { checkUniqueness, updateFormField  } from 'store/forms/actions';

const AppTrackPageSupplier = ({ disabled }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [selectedProcId, setSelectedProcId] = useState();
  const [isFiltersVisible, setFiltersVisible] = useState(false);
  const [filterImg, setFilterImg] = useState(<FilterIcon />);
  const user = useSelector(state => state.user);
  const userStatus = useSelector(state => state.user.status);
  const [saytOptions, setSaytOptions] = useState([]);
  //const saytOptions = useSelector(state => state.appTrack.sayt);
  const [detailedPayload, setDetailedPayload] = useState({ parameterList: [] });
  const privileges = useSelector(state => state.user.privileges);
  const groups = useSelector(state => state.user.groups);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [open, setOpen] = useState(Boolean(anchorEl));
  const { Option } = Select;
  const { RangePicker } = DatePicker;
  const results = useSelector(state => state.appTrack.variables);
  // const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const locales = useSelector(state => state.forms?.localeStrings);
  const loadingPage = useSelector(state => state.appTrack.loadingApptrack);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSizeFlag, setPageSizeFlag] = useState(5);
  const resultSize = useSelector(state => state.appTrack.resultSize);
  const taskNames = useSelector(state => state.appTrack.taskNames);
  const sayt = useSelector(state => state.appTrack.sayt);
  // const isKTP = user.groups?.map(item=>item.name).includes("KTP");
  const [cancelModal, setCancelModal] = useState(false);
  const [cancelModalEquipment, setCancelModalEquipment] = useState(false);
  const [cancelModalService, setCancelModalService] = useState(false);
  const checkUniquenessCreate = useSelector(
    state => state.forms.checkUniquenessCreate
  );
  const kadBranches = useSelector(state => state.forms.kadBranches);
  const iniFlag = useSelector(state => state.user.taxis_data.iniFlag);
  const [unassignModalService, setUnassignModalService] = useState(false);
  const loadingLocales = useSelector(state => state.forms.loadingLocales);
  const loadingTaxis = useSelector(state => state.user.loading);
  const currentDate = new Date().toISOString().split('T')[0];

  useEffect(() => {
    const storedLanguage = localStorage.getItem('appLanguage');
    dispatch(getSystemLocales(storedLanguage));
    dispatch(checkUser(navigate));
    dispatch(getUser());
    dispatch(getTaxisData());
    dispatch(clearForm());
    dispatch(fetchProcInstancesDetailedPaginated(detailedPayload,currentPage, pageSizeFlag));
    // dispatch(fetchProcInstancesDetailed());
    dispatch(getAllTaskNames());
  }, [dispatch, navigate]);

  useEffect(() => {
    if (user?.taxis_data?.afm) {
      handleCheckUniqueness({
        user,
        apptrack: true,
        dispatch,
        checkUniqueness,
      }).then(res => {
        // const reasons = {
        //   case: 'checkUniqueness',
        //   acceptable: true,//res.acceptable,
        // };
        dispatch(
          updateFormField({
            group: 'checkUniquenessCreate',
            key: 'canCreate',
            value: res.acceptable,
          })
        );
      });
      
      dispatch(kadBranchesService(user?.taxis_data?.afm, currentDate));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user?.taxis_data?.afm]);

  useEffect(()=> {
    if(isForeign(user?.groups)){
      dispatch(
          updateFormField({
            group: 'checkUniquenessCreate',
            key: 'canCreate',
            value: true,
          })
        );
    }
  },[user?.groups])

   const unassignProcessService = (selectedProcId) => {
    dispatch(unassignProcessInstanceExtended(selectedProcId)); 
    setUnassignModalService(false);
  };


  const dateFormat = 'DD/MM/YYYY';

  const handlePageChange = (page,pageSize) => {
    setCurrentPage(page);
    setPageSizeFlag(pageSize);
    dispatch(fetchProcInstancesDetailedPaginated(detailedPayload ,page, pageSize)); //empty param list
  };

  const renderTitle = title => <span>{title}</span>;

  const renderItem = title => ({
    value: title,
    label: (
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
        }}
      >
        {title}
      </div>
    ),
  });

  const toggleFilters = () => {
    setFiltersVisible(!isFiltersVisible);
    if (isFiltersVisible) {
      setFilterImg(<FilterIconBold />);
    } else {
      setFilterImg(<FilterIcon />);
    }
  };

  const overFilter = () => {
    setFilterImg(<FilterIconBold />);
  };

  const outFilter = () => {
    if (isFiltersVisible) {
      setFilterImg(<FilterIconBold />);
    } else {
      setFilterImg(<FilterIcon />);
    }
  };

  const cancelProcess = selectedProcId => {
    dispatch(cancelProcessInstance(selectedProcId)); // isEquipment = true
    setCancelModal(false);
  };

  const filterText = isFiltersVisible ? 'filterText' : 'filterTextDefault';

  // const onSelectChange = (newSelectedRowKeys) => {
  //   setSelectedRowKeys(newSelectedRowKeys);
  // };

  // const rowSelection = {
  //   selectedRowKeys,
  //   onChange: onSelectChange,
  //   getCheckboxProps: (record) => {
  //     return {
  //         disabled: record.applStatus !== "AS_1G" && record.applStatus !== "AS_6B"
  //     }
  //   }
  // };

  useEffect(() => {
    if (!isEmpty(detailedPayload) && userStatus)
      setCurrentPage(1);
      dispatch(fetchProcInstancesDetailedPaginated(detailedPayload, 1, pageSizeFlag))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [detailedPayload]);

  const saytOptionsTmp = [];

  const handleSAYT = value => {
    if (value.length >= 3) {
      dispatch(fetchProcessSAYT(value));
    }
  };

  useEffect(() => {
    if (sayt && !isEmpty(sayt)) {
      // eslint-disable-next-line array-callback-return
      Object.values(sayt).map(key => {
        const opt = { options: [] };
        if (key?.name !== 'limitExceeded') {
          if (key?.name === 'abiVat' || key?.name === 'legalVat') {
            opt.label = renderTitle('Α.Φ.Μ.');
          } else if (key?.name === 'businessKey') {
            opt.label = renderTitle('Αρ Αίτησης');
          } else if (key?.name === 'companyName') {
            opt.label = renderTitle('Επωνυμία');
          } else if (key?.name === 'abiDistrict') {
            opt.label = renderTitle('Περιοχή');
          }
          const uniqueValues = new Set();

         for (let value of key?.values ?? []) {
          if (!uniqueValues.has(value.value)) {
            uniqueValues.add(value.value);
            opt.options.push(renderItem(value.value));
          }
        }
        saytOptionsTmp.push(opt);
        }
        setSaytOptions(saytOptionsTmp);
      });
    } else {
      setSaytOptions([]);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sayt]);

  const prefix = <SearchIcon style={{ marginRight: '14px' }} />;

  const onSAYTSelect = value => {
    const detailedPayloadTmp = JSON.parse(JSON.stringify(detailedPayload));
    // detailedPayloadTmp["saytKey"] = value;
    // setDetailedPayload(detailedPayloadTmp);
    if (!isNil(value)) {
      if (
        detailedPayloadTmp.parameterList
          .map(i => i.qualifier.includes('sayt'))
          .includes(true)
      ) {
        const filteredList = detailedPayloadTmp.parameterList.map(obj => {
          if (obj.qualifier === 'sayt') {
            return { ...obj, value: value };
          } else {
            return { ...obj };
          }
        });

        const parameterList = {
          parameterList: filteredList,
        };
        setDetailedPayload(parameterList);
      } else {
        detailedPayloadTmp.parameterList.push({
          qualifier: 'sayt',
          type: 'STRING_VALUE',
          value: value,
        });
        setDetailedPayload(detailedPayloadTmp);
      }
    } else {
      const filteredList = detailedPayloadTmp.parameterList.filter(
        i => i.qualifier !== 'sayt'
      );
      const parameterList = {
        parameterList: filteredList,
      };
      setDetailedPayload(parameterList);
    }
  };

  const onSAYTSearch = value => {
    const detailedPayloadTmp = JSON.parse(JSON.stringify(detailedPayload));
    if (!isNil(value)) {
      if (
        detailedPayloadTmp.parameterList
          .map(i => i.qualifier.includes('sayt'))
          .includes(true)
      ) {
        const filteredList = detailedPayloadTmp.parameterList.map(obj => {
          if (obj.qualifier === 'sayt') {
            return { ...obj, value: value };
          } else {
            return { ...obj };
          }
        });

        const parameterList = {
          parameterList: filteredList,
        };
        setDetailedPayload(parameterList);
      } else {
        detailedPayloadTmp.parameterList.push({
          qualifier: 'sayt',
          type: 'STRING_VALUE',
          value: value,
        });
        setDetailedPayload(detailedPayloadTmp);
      }
    } else {
      const filteredList = detailedPayloadTmp.parameterList.filter(
        i => i.qualifier !== 'sayt'
      );
      const parameterList = {
        parameterList: filteredList,
      };
      setDetailedPayload(parameterList);
    }
  };

  const onSAYTChange = value => {
    if (value.length === 0) {
      dispatch(clearSayt());
      setSaytOptions([]);
      const detailedPayloadTmp = JSON.parse(JSON.stringify(detailedPayload));
      // delete detailedPayloadTmp.saytKey;
      // setDetailedPayload(detailedPayloadTmp);
      const filteredList = detailedPayloadTmp.parameterList.filter(
        i => i.qualifier !== 'sayt'
      );
      const parameterList = {
        parameterList: filteredList,
      };
      setDetailedPayload(parameterList);
    }
  };

  const onStatusChange = value => {
    const detailedPayloadTmp = JSON.parse(JSON.stringify(detailedPayload));
    // console.log(detailedPayloadTmp, value)
    if (!isNil(value)) {
      if (
        detailedPayloadTmp.parameterList
          .map(i => i.qualifier.includes('activeTaskName'))
          .includes(true)
      ) {
        const filteredList = detailedPayloadTmp.parameterList.map(obj => {
          if (obj.qualifier === 'activeTaskName') {
            return { ...obj, value: [value] };
          } else {
            return { ...obj };
          }
        });

        const parameterList = {
          parameterList: filteredList,
        };
        setDetailedPayload(parameterList);
      } else {
        detailedPayloadTmp.parameterList.push({
          qualifier: 'activeTaskName',
          type: 'STRING_LIST',
          value: [value],
        });
        setDetailedPayload(detailedPayloadTmp);
      }
    } else {
      const filteredList = detailedPayloadTmp.parameterList.filter(
        i => i.qualifier !== 'activeTaskName'
      );
      const parameterList = {
        parameterList: filteredList,
      };
      setDetailedPayload(parameterList);
    }
  };

  // const onFilterChange = (value, qualifier, type) => {
  //   const detailedPayloadTmp = JSON.parse(JSON.stringify(detailedPayload));

  //   if (!isNil(value)) {
  //     if(detailedPayloadTmp.parameterList.map(i => i.qualifier.includes(qualifier)).includes(true)){
  //       const filteredList = detailedPayloadTmp.parameterList.map(obj => {

  //         if(obj.qualifier === qualifier){
  //           return { ...obj,
  //             value: value
  //           }
  //         }else {
  //           return { ...obj }
  //         }
  //       })

  //       const parameterList = {
  //         "parameterList" : filteredList
  //       };
  //       setDetailedPayload(parameterList);
  //     }else{
  //       detailedPayloadTmp.parameterList.push({
  //         qualifier: qualifier,
  //         type: type,
  //         value: value,
  //       });
  //       setDetailedPayload(detailedPayloadTmp);
  //     }
  //   }
  //   else {
  //     const filteredList = detailedPayloadTmp.parameterList.filter(i => i.qualifier !== qualifier )
  //     const parameterList = {
  //       "parameterList" : filteredList
  //     };
  //     setDetailedPayload(parameterList)
  //   }

  // };

  const onDateRangeChange = (value, dateString) => {
    const detailedPayloadTmp = JSON.parse(JSON.stringify(detailedPayload));

    if (!isNil(value)) {
      if (!isEmpty(dateString[0]) && !isEmpty(dateString[1])) {
        const filteredList = detailedPayloadTmp.parameterList.map(obj => {
          if (obj.qualifier === 'submission_date') {
            return { ...obj, from: dateString[0], to: dateString[1] };
          } else {
            return { ...obj };
          }
        });

        const parameterList = {
          parameterList: filteredList,
        };
        setDetailedPayload(parameterList);
      } else {
        detailedPayloadTmp.parameterList.push({
          qualifier: 'submission_date',
          type: 'RANGE_DATE',
          from: dateString[0],
          to: dateString[1],
        });
        setDetailedPayload(detailedPayloadTmp);
      }
    } else {
      const filteredList = detailedPayloadTmp.parameterList.filter(
        i => i.qualifier !== 'submission_date'
      );
      const parameterList = {
        parameterList: filteredList,
      };
      setDetailedPayload(parameterList);
    }
  };

  // const onSliderChange = (value) => {
  //   const detailedPayloadTmp = JSON.parse(JSON.stringify(detailedPayload));

  //   if (!isNil(value)) {
  //     if(!isEmpty(value[0]) && !isEmpty(value[1])){
  //       const filteredList = detailedPayloadTmp.parameterList.map(obj => {

  //         if(obj.qualifier === "totalValue"){
  //           return { ...obj,
  //             from: value[0],
  //             to: value[1]
  //           }
  //         }else {
  //           return { ...obj }
  //         }
  //       })

  //       const parameterList = {
  //         "parameterList" : filteredList
  //       };
  //       setDetailedPayload(parameterList);

  //     }else {
  //       detailedPayloadTmp.parameterList.push({
  //         qualifier: "totalValue",
  //         type: "RANGE_VALUE",
  //         from: value[0],
  //         to: value[1]
  //       });
  //       setDetailedPayload(detailedPayloadTmp);
  //     }
  //   } else {
  //     const filteredList = detailedPayloadTmp.parameterList.filter(i => i.qualifier !== "totalValue" )
  //     const parameterList = {
  //       "parameterList" : filteredList
  //     };
  //     setDetailedPayload(parameterList);
  //   }
  // };

  const id = open ? 'simple-popover' : 'simple-popover';

  useEffect(() => {
    const intervalId = setInterval(() => {
      dispatch(checkUser(navigate));
    }, process.env.REACT_APP_SESSION_CHECK_TIME);
    return () => clearInterval(intervalId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onMoreClick = (id, b_key) => event => {
    setSelectedProcId(id);
    dispatch(setActiveFormId(id));
    // setSelectedBusinessKey(b_key);
    // setSelectedBusKey(b_key);
    setAnchorEl(event.currentTarget);
    setOpen(true);
    // setUsers([]);
    // setSelectedUser(null);
    // setAssignDisabled(false);
  };

  const handleClose = () => {
    setOpen(false);
    setAnchorEl(null);
  };

  const getStatusTag = status => {
    switch(status) {
        //Υποβολή Αίτησης
        case 'task.name.submit_application':
            return getLocalString(locales, localNames.TASK_NAME_APPLICATION_SUBMISSION);
        //Επιστροφή στον Ωφελούμενο
        case 'task.name.application_returned_to_supplier':
            return getLocalString(locales, localNames.TASK_NAME_APPLICATION_RETURNED_TO_SUPPLIER);; 
        //Αξιολόγηση Αίτησης
        case 'task.name.audit_application':
            return getLocalString(locales, localNames.TASK_NAME_APPLICATION_EVALUATION); 
        //Απόρριψη
        case 'task.name.temporary_rejected':
            return getLocalString(locales, localNames.TASK_NAME_APPLICATION_REJECTED); 
        //Υποβολή Αξιολόγησης
        case 'task.name.accepted':
            return getLocalString(locales, localNames.TASK_NAME_APPLICATION_ACCEPTED);
        //Προς Αξιολόγηση από Επιτροπή
        case 'task.name.application_evaluation_before_committee':
            return getLocalString(locales, localNames.TASK_NAME_APPLICATION_EVALUATION_BEFORE_COMMITTEE);    
        //Εκδοση προσωρινής Κατάταξης
        case 'task.name.issuance_of_provisional_classification':
            return getLocalString(locales, localNames.TASK_NAME_ISSUANCE_OF_PROVISIONAL_CLASSIFICATION);
        //Υποβολή Ένστασης
        case 'task.name.objection_submission':
            return getLocalString(locales, localNames.TASK_NAME_OBJECTION_SUBMISSION); 
        //Αξιολόγηση ΕΕ
        case 'task.name.objection_evaluation':
            return getLocalString(locales, localNames.TASK_NAME_OBJECTION_EVALUATION);
        //Αξιολόγηση Ενστάσεων - Απόρριψη Ένστασης
        case 'task.name.application_rejection':
            return getLocalString(locales, localNames.TASK_NAME_APPLICATION_REJECTION); 
        //Εκδοση τελικής Κατάταξης
        case 'task.name.final_classification':
            return getLocalString(locales, localNames.TASK_NAME_FINAL_CLASSIFICATION);
        //ακύρωση Αίτησης
        case 'task.name.cancelled_task':
            return getLocalString(locales, localNames.TASK_NAME_CANCEL); 
        case 'task.name.program_implementation':
            return getLocalString(locales, localNames.REQUEST_STATUS_PROGRAMIMPLEMENTATION);
        default:
            return null;
  }
  };


  const beneficiaryColumns = [
    {
      title: 'Αριθμός Αίτησης',
      dataIndex: 'businessKey',
      key: 'businessKey',
      render: (text, record) => {
        return (
          <TableCell
            id={`businessKey-cell-${record.businessKey}`}
            text={text}
          />
        );
      },
      sorter: {
        compare: (a, b) => a.businessKey - b.businessKey,
      },
      width: 85,
      //fixed: 'left',
    },
    {
      title: 'Α.Φ.Μ.',
      dataIndex: 'abiVat',
      key: 'abiVat',
      render: (text, record) => {
        return (
          <TableCell
            id={`businessKey-cell-${record.businessKey}`}
            text={text}
          />
        );
      },
      sorter: {
        compare: (a, b) => a.abiVat - b.abiVat,
      },
      width: 120,
      //fixed: 'left',
    },
    {
      title: 'Επωνυμία',
      dataIndex: 'companyName',
      key: 'companyName',
      render: (text, record) => {
        return (
          <TableCell
            id={`businessKey-cell-${record.companyName}`}
            text={text}
          />
        );
      },
      sorter: {
        compare: (a, b) => a.companyName - b.companyName,
      },
      width: 220,
      //fixed: 'left',
    },
    {
      title: 'Status',
      dataIndex: 'activeTaskName',
      key: 'activeTaskName',
      render: (text, record) => {
        return (
          <StatusTag
            id={`activeTaskName-cell-${record.businessKey}`}
            status={text}
          />
        );
      },
      sorter: {
        compare: (a, b) => {
          // Check if both properties exist and are strings
          if (
            typeof getStatusTag(a.activeTaskName) === 'string' &&
            typeof getStatusTag(b.activeTaskName) === 'string'
          ) {
            return getStatusTag(a.activeTaskName).localeCompare(
              getStatusTag(b.activeTaskName)
            );
          }

          // Handle cases where one or both properties don't exist or aren't strings
          if (
            typeof getStatusTag(a.activeTaskName) !== 'string' &&
            typeof getStatusTag(b.activeTaskName) === 'string'
          ) {
            return -1; // a comes first if b has valid activeTaskName but a doesn't
          }
          if (
            typeof getStatusTag(a.activeTaskName) === 'string' &&
            typeof getStatusTag(b.activeTaskName) !== 'string'
          ) {
            return 1; // b comes first if a has valid activeTaskName but b doesn't
          }
          return 0; // If neither a nor b have valid activeTaskName, treat them as equal
        },
      },
       width: 120,
      //className: 'col-2',
    },
    {
      title: 'Περιοχή',
      dataIndex: 'abiDistrict',
      key: 'abiDistrict',
      className: 'col-2',
      render:(text, record) => {
        return <TableCell 
          id={`district-cell-${record?.isForeignSupplier ? record?.abiCountry : record?.abiDistrict}`} 
          text={(record?.isForeignSupplier ? record?.abiCountry : record?.abiDistrict) || '-'} 
        />;
      },
      width: 260,
    },
    {
      title: 'Νομός',
      dataIndex: 'abiPerfecture',
      key: 'abiPerfecture',
      className: 'col-2',
      render:(text, record) => {
        return <TableCell 
          id={`district-cell-${record?.isForeignSupplier ? record?.abiCity : record?.abiPerfecture}`} 
          text={(record?.isForeignSupplier ? record?.abiCity : record?.abiPerfecture) || '-'} 
        />;
      },
      width: 260,
    },
    {
      title: 'Υποβολή',
      dataIndex: 'submissionDate',
      key: 'submissionDate',
      render: (text, record) => {
        const fullDateTime = getFullDateTimeWithSeconds(text);
        // Split date and time
        const [datePart, timePart] = fullDateTime.split(' ');
        
        return (
          <TableCell
            id={`submissionDate-cell-${record.businessKey}`}
            text={
              <div className="date-time-container">
                <div className="date-part">{datePart}</div>
                <div className="time-part">{timePart}</div>
              </div>
            }
          />
        );
      },
      sorter: {
        compare: (a, b) => {
          if (a.submissionDate && b.submissionDate) {
            return new Date(a.submissionDate) - new Date(b.submissionDate);
          } else if (!a.submissionDate && b.submissionDate) {
            return -1;
          } else if (a.submissionDate && !b.submissionDate) {
            return 1;
          } else {
            return 0;
          }
        },
      },
      width: 90, 
    },
    {
      title: '',
      //fixed: 'right',
      key: 'action',
      align: 'right',
      render: (text, record) => {
        return (
          <Space
            id={`action-cell-${record.businessKey}`}
            align="end"
            style={{ width: 'auto', marginRight: '2rem' }}
          >
            <Tooltip title="Actions">
              {/* <ActionsIcon aria-describedby={id} onClick={(e) => onMoreClick(record.id, record.businessKey)(e)} style={{ cursor: "pointer"}} /> */}
              {/* <Button 
                  shape="circle"
                  onClick={(e) => onMoreClick(record.id, record.businessKey)(e)}
                  icon={<ActionsIcon aria-describedby={id} />}
                  size="small"
                  style={{ height: "8px", width: "8px"}}
                  /> */}
              <Button
                shape="circle"
                onClick={e => onMoreClick(record.id, record.businessKey)(e)}
                size="large"
                // style={{ height: "8px", width: "8px"}}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  // width: "12px"
                  padding: 0,
                  width: '8px',
                }}
              >
                <ActionsIcon
                  aria-describedby={id}
                  style={{ width: '16px', margin: 0 }}
                />
              </Button>
            </Tooltip>
          </Space>
        );
      },
      width: 90, 
    },
  ];

  const auditorColumns = [
    {
      title: 'Αριθμός Αίτησης',
      dataIndex: 'businessKey',
      key: 'businessKey',
      render: (text, record) => {
        return (
          <TableCell
            id={`businessKey-cell-${record.businessKey}`}
            text={text}
          />
        );
      },
      sorter: {
        compare: (a, b) => a.businessKey - b.businessKey,
      },
      width: 85,
      fixed: 'left',
    },
    {
      title: 'Α.Φ.Μ.',
      dataIndex: 'abiVat',
      key: 'abiVat',
      render: (text, record) => {
        return (
          <TableCell
            id={`businessKey-cell-${record.businessKey}`}
            text={text}
          />
        );
      },
      sorter: {
        compare: (a, b) => a.abiVat - b.abiVat,
      },
      width: 120,
      fixed: 'left',
    },
    {
      title: 'Επωνυμία',
      dataIndex: 'companyName',
      key: 'companyName',
      render: (text, record) => {
        return (
          <TableCell
            id={`businessKey-cell-${record.companyName}`}
            text={text}
          />
        );
      },
      sorter: {
        compare: (a, b) => a.companyName - b.companyName,
      },
      width: 220,
      fixed: 'left',
    },
    {
      title: 'Status',
      dataIndex: 'activeTaskName',
      key: 'activeTaskName',
      render: (text, record) => {
        return (
          <StatusTag
            id={`activeTaskName-cell-${record.businessKey}`}
            status={text}
          />
        );
      },
      sorter: {
        compare: (a, b) => {
          // Check if both properties exist and are strings
          if (
            typeof getStatusTag(a.activeTaskName) === 'string' &&
            typeof getStatusTag(b.activeTaskName) === 'string'
          ) {
            return getStatusTag(a.activeTaskName).localeCompare(
              getStatusTag(b.activeTaskName)
            );
          }

          // Handle cases where one or both properties don't exist or aren't strings
          if (
            typeof getStatusTag(a.activeTaskName) !== 'string' &&
            typeof getStatusTag(b.activeTaskName) === 'string'
          ) {
            return -1; // a comes first if b has valid activeTaskName but a doesn't
          }
          if (
            typeof getStatusTag(a.activeTaskName) === 'string' &&
            typeof getStatusTag(b.activeTaskName) !== 'string'
          ) {
            return 1; // b comes first if a has valid activeTaskName but b doesn't
          }
          return 0; // If neither a nor b have valid activeTaskName, treat them as equal
        },
      },
      width: 120,
      //className: 'col-2',
    },
    {
      title: 'Περιοχή',
      dataIndex: 'abiDistrict',
      key: 'abiDistrict',
      className: 'col-2',
      render:(text, record) => {
        return <TableCell 
          id={`district-cell-${record?.isForeignSupplier ? record?.abiCountry : record?.abiDistrict}`} 
          text={(record?.isForeignSupplier ? record?.abiCountry : record?.abiDistrict) || '-'} 
        />;
      },
      width: 260,
    },
    {
      title: 'Νομός',
      dataIndex: 'abiPerfecture',
      key: 'abiPerfecture',
      className: 'col-2',
      render:(text, record) => {
        return <TableCell 
          id={`district-cell-${record?.isForeignSupplier ? record?.abiCity : record?.abiPerfecture}`} 
          text={(record?.isForeignSupplier ? record?.abiCity : record?.abiPerfecture) || '-'} 
        />;
      },
      width: 260,
    },
    {
      title: "Αξιολογητής",
      dataIndex: 'evaluator',
      key: 'evaluator',
      render: (text, record) => {
        return <TableCell 
          id={`evaluator-cell-${record.businessKey}`} 
          text={record?.evaluator || '-'} 
        />;
      },
      sorter: {
        compare: (a, b) => {
          const evaluatorA = a.evaluator || '';
          const evaluatorB = b.evaluator || '';
          return evaluatorA.localeCompare(evaluatorB);
        },
      },
      className: "col-3",
      width: 180,
    },
    {
      title: 'Υποβολή',
      dataIndex: 'submissionDate',
      key: 'submissionDate',
      render: (text, record) => {
        const fullDateTime = getFullDateTimeWithSeconds(text);
        // Split date and time
        const [datePart, timePart] = fullDateTime.split(' ');
        
        return (
          <TableCell
            id={`submissionDate-cell-${record.businessKey}`}
            text={
              <div className="date-time-container">
                <div className="date-part">{datePart}</div>
                <div className="time-part">{timePart}</div>
              </div>
            }
          />
        );
      },
      sorter: {
        compare: (a, b) => {
          if (a.submissionDate && b.submissionDate) {
            return new Date(a.submissionDate) - new Date(b.submissionDate);
          } else if (!a.submissionDate && b.submissionDate) {
            return -1;
          } else if (a.submissionDate && !b.submissionDate) {
            return 1;
          } else {
            return 0;
          }
        },
      },
      width: 90, 
    },
    {
      title: '',
      fixed: 'right',
      key: 'action',
      align: 'right',
      render: (text, record) => {
        return (
          <Space
            id={`action-cell-${record.businessKey}`}
            align="end"
            style={{ width: 'auto', marginRight: '2rem' }}
          >
            <Tooltip title="Actions">
              <ActionsIcon
                aria-describedby={id}
                onClick={e => onMoreClick(record.id, record.businessKey)(e)}
                style={{ cursor: 'pointer' }}
              />
            </Tooltip>
          </Space>
        );
      },
      width: 90,
    },
  ];

  return loadingTaxis || loadingLocales ? (
    <div
      style={{
        position: 'absolute',
        left: '50%',
        top: '50%',
      }}
    >
      <Spin size="large" />
    </div>
  ) : (
    <main>
      <Modal
        id={`cancel-modal-${selectedProcId}`}
        centered
        width={400}
        open={cancelModal}
        className={`custom-modal`}
        onCancel={() => setCancelModal(false)}
        onOk={() => setCancelModal(false)}
        closable={false}
        footer={null}
      >
        <div className="image_modal">
          <CancelWarningIcon />
        </div>
        <div className="modal_info">
          <h3>Επιβεβαίωση Ακύρωσης Αίτησης</h3>
          <p>
          Πρόκειται να ακυρώσετε την αίτηση ένταξής σας στο Μητρώο Προμηθευτών του Προγράμματος "Αλλάζω Σύστημα Θέρμανσης και Θερμοσίφωνα". 
          </p>
          <p>Παρακαλούμε επιβεβαιώστε την ενέργεια, διαφορετικά επιλέξτε Ακύρωση.
          </p>
          <p>Η ενέργεια είναι ΜΗ αναστρέψιμη.</p>
        </div>
        <div className="footerBtnContainer">
          <div
            id={'cancel-modal-cancel-button'}
            className="cancel-btn-assign"
            onClick={() => setCancelModal(false)}
          >
            Επιστροφή
          </div>
          <div
            id={`cancel-modal-ok-button-${selectedProcId}`}
            onClick={() => cancelProcess(selectedProcId)}
            className="btn-assign"
          >
            Επιβεβαίωση
          </div>
        </div>
      </Modal>

      <Modal
        id={`unassign-modal-${selectedProcId}`}
        centered
        width={400}
        open={unassignModalService}
        className={`custom-modal`}
        onCancel={() => setUnassignModalService(false)}
        onOk={() => setUnassignModalService(false)}
        closable={false}
        footer={null}
        >
        <div className="image_modal">
          <CancelWarningIcon />
        </div>
        <div className="modal_info">
          <h3>Επιβεβαίωση Ανάθεσης σε άλλον αξιολογητή</h3>
          <p>Είστε σίγουροι ότι επιθυμείτε να ανεθέσετε σε άλλον αξιολογητή την αίτηση;</p>
          <p>Προσοχή η ενέργεια είναι μη αναστρέψιμη.</p>
        </div>
        <div className="footerBtnContainer">
          <div id={'cancel-modal-cancel-button'} className="cancel-btn-assign" onClick={() => setUnassignModalService(false)}>
            Επιστροφή
          </div>
          <div id={`cancel-modal-ok-button-${selectedProcId}`} onClick={() => unassignProcessService(selectedProcId)} className="btn-assign">
            Επιβεβαίωση
          </div>
        </div>
        </Modal>

      <div>
         <div>
          <div>
            <Popover
              id={id}
              open={open}
              anchorEl={anchorEl}
              onClose={handleClose}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "center",
              }}
            >
              <ActionList 
                open={setOpen} 
                id={selectedProcId}
                payload={detailedPayload} 
                setCancelModal={setCancelModal}
                setCancelModalService={setCancelModalService}
                setUnassignModalService={setUnassignModalService}
              />
            </Popover>
          </div>
        </div>

        <div style={{ marginTop: '30px', marginBottom: '21px' }}>
          {/* {privileges?.includes("CanRenderSAYT") && !isBeneficiary(groups) && ( */}
          {true && (
            <div style={{ marginTop: '30px', marginBottom: '21px' }}>
              <AutoComplete
                popupClassName="certain-category-search-dropdown"
                dropdownMatchSelectWidth={500}
                style={{ width: '100%' }}
                options={saytOptions}
                onSearch={handleSAYT}
                onSelect={onSAYTSelect}
                onChange={onSAYTChange}
                defaultValue={detailedPayload?.saytKey}
              >
                <Input.Search
                  id="autocomplete-search-input"
                  onSearch={onSAYTSearch}
                  bordered={false}
                  allowClear={true}
                  prefix={prefix}
                  className="sayt-input-filter input-filter"
                  size="large"
                  // placeholder={getLocalString(
                  //   locales,
                  //   isKTP ? localNames.HOME_PAGE_SEARCHKTP :
                  //   isBeneficiary(groups) ? localNames.HOME_PAGE_SEARCHNP :
                  //   ''
                  // )}
                  placeholder="Αναζήτηση με Αρ. Αίτησης, ΑΦΜ, Επωνυμία, Περιοχή"
                  enterButton
                />
              </AutoComplete>
            </div>
          )}

          {privileges?.includes('CanRenderAppFilters') && (
            <div>
              <Tooltip placement="right" title="Expanded Filters">
                <Space
                  id="filters-toggle-button"
                  onClick={() => toggleFilters()}
                  onMouseEnter={() => overFilter()}
                  onMouseLeave={() => outFilter()}
                  className="filterButton mt-3"
                >
                  {filterImg}
                  <span className={filterText}>
                    {getLocalString(
                      locales,
                      localNames.HOME_PAGE_FILTERSBUTTON
                    )}
                  </span>
                </Space>
              </Tooltip>

              {isFiltersVisible && (
                <div className="filtersContainer">
                  <div className="filters-wrapper">
                    <div style={{ flex: '1' }}>
                      <Select
                        id="select-application-status"
                        suffixIcon={<ArrowIcon />}
                        className="input-filter"
                        style={{ width: '100%' }}
                        dropdownAlign={{ offset: [-11, 5] }}
                        showSearch
                        allowClear={true}
                        placeholder={
                          getLocalString(
                            locales,
                            localNames?.HOME_PAGE_FILTERS_STATUS
                          ) || 'Status'
                        }
                        optionFilterProp="children"
                        onChange={onStatusChange}
                        filterOption={(input, option) =>
                          option.children
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                      >
                        {taskNames?.map(item => (
                          <Option
                            id={`status-${item.name}-option`}
                            key={item.name}
                            value={item.name}
                          >
                            {getLocalString(locales, item.name)}
                          </Option>
                        ))}
                      </Select>
                    </div>

                    <div style={{ flex: '1' }}>
                      <RangePicker
                        id="application-results-date-range-picker-from"
                        locale={{
                          ...locale,
                          lang: {
                            ...locale.lang,
                            rangePlaceholder: [
                              getLocalString(
                                locales,
                                localNames.HOME_PAGE_FILTERS_DATEFROM
                              ),
                              getLocalString(
                                locales,
                                localNames.HOME_PAGE_FILTERS_DATETO
                              ),
                            ],
                          },
                        }}
                        format={dateFormat}
                        suffixIcon={<CalendarIcon />}
                        allowEmpty={[true, true]}
                        onCalendarChange={onDateRangeChange}
                        className="input-filter"
                        style={{ width: '100%', height: 'unset !important' }}
                      />
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}

          <Divider className="filter-divider" />
          {loadingPage && (
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <Spin
                id="apptrack-application-results-table-spinner"
                size="default"
              />
            </div>
          )}
          {!loadingPage && (
            <Row gutter={32}>
              <Col span={24}>
                {!isEmpty(results) &&
                  ((kadBranches?.isDirectSupplier || kadBranches?.isIndirectSupplier) || !isBeneficiary(groups) || isForeign(groups)) && (
                    <div>
                      <Table
                        scroll={{ x: true }}
                        id="apptrack-application-results-table"
                        className="results-table"
                        dataSource={results}
                        columns={
                          isBeneficiary(user.groups)
                            ? beneficiaryColumns
                            : auditorColumns
                        }
                        rowKey="id"
                        pagination={{
                          total:resultSize,
                          current:currentPage,
                          showSizeChanger: true,
                          showTitle: true,
                          pageSizeOptions:[5,10,20,50,100,200], 
                          pageSize:pageSizeFlag,
                          onChange: (page, pageSize) => {
                            handlePageChange(page, pageSize);
                           },
                        }}
                      />
                    </div>
                  )}

                {(isEmpty(results) && checkUniquenessCreate?.canCreate && (kadBranches?.isDirectSupplier || kadBranches?.isIndirectSupplier || isForeign(groups))) && (
                  <NoResults
                    id="apptrack-application-results-no-results"
                    description={'Δε βρέθηκαν αποτελέσματα'}
                    subDescription={''}
                  />
                )}

                {!isNil(kadBranches) && !(kadBranches?.isDirectSupplier) && !(kadBranches?.isIndirectSupplier) && isBeneficiary(groups) && (
                  <NoResults
                    id="apptrack-application-results-no-results"
                    description={
                      'Δεν είστε εγκεκριμένος χρήστης του συστήματος Αλλάζω Συσκευή Θέρμανσης - Θερμοσίφωνες.'
                    }
                    subDescription={
                      <>
                        {kadBranches?.getAllKadBranchesReturn?.resultKadDesc ?
                          <div>{kadBranches?.getAllKadBranchesReturn?.resultKadDesc} <br/><br/></div>
                          : ''
                        }                        
                        Παρακαλώ, Ξανασυνδεθείτε με διαφορετικό Χρήστη, ή απευθυνθείτε στο Help Desk του προγράμματος.
                      </>
                    }
                  />
                )}
              </Col>
            </Row>
          )}
        </div>
      </div>
    </main>
  );
};

export default AppTrackPageSupplier;
